import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Grupo} from '../model/grupo/grupo.model';
import {IdNome} from '../model/id-nome.model';

@Injectable({
  providedIn: 'root'
})
export class GrupoService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/grupo`;

  buscarGrupos(): Observable<Grupo[]> {
    return this.http.get<Grupo[]>(this.urlBase);
  }

  salvarGrupo(grupo: Grupo): Observable<number> {
    return this.http.post<number>(this.urlBase, grupo)
  }

  buscarGrupoSelect(): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(`${this.urlBase}/buscar/select`);
  }
  buscarGrupoSelectTodos(): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(`${this.urlBase}/buscar/select/todos`);
  }
}
